import Table from "components/Table";

export default function UserLog() {
    return (
        <div className="warp-debtor-creaditor">
            <Table type="userLogs" withDateFilter/>
        </div>
    );
}
